import { makeStyles } from '@material-ui/core'

/**
 * ONE column-ratio constant, shared by the head and the rows.
 *
 * The conventions doc names this explicitly: `ChannelsTable.styles.ts` repeats its ratio at
 * two line numbers and they have drifted. A head that no longer lines up with its rows is the
 * failure mode, and it is invisible until someone adds a column.
 */
const COLUMNS = '3fr 2fr 2fr 2fr 1.5fr 2fr'

const useStyles = makeStyles((theme) => ({
  caption: {
    padding: theme.spacing(0, 2, 1),
    fontWeight: 600
  },
  tableHead: {
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    color: theme.palette.text.secondary
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    gap: theme.spacing(1),
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    background: theme.palette.background.paper,
    marginBottom: theme.spacing(1)
  },
  name: {
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  numeric: {
    // `end`, a LOGICAL value — correct in both directions without depending on the flipper.
    //
    // An earlier comment here claimed jss-rtl cannot flip textAlign and used that to justify
    // no alignment at all. The premise is wrong (the portal uses textAlign: 'right' and
    // 'left' in several screens and relies on it flipping), and the consequence was real:
    // start-aligned ragged numerals defeat exactly the down-a-column magnitude scan this
    // screen exists for. `end` makes the question moot either way.
    textAlign: 'end',
    overflowWrap: 'anywhere'
  },
  muted: {
    color: theme.palette.text.secondary
  },
  empty: {
    padding: theme.spacing(4, 2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  }
}))

export default useStyles
